import { D as DialogExt } from './dialog-BxVV6X1H.js';
import './focus-trap.esm-C-N_-G0z.js';
import './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class MenuPane extends DialogExt {
  open() {
    this.#resetScrollToTop();
    super.open();
  }

  #resetScrollToTop() {
    const drawerContent = this.closest('.drawer__content');
    if (drawerContent) {
      drawerContent.scrollTop = 0;
      return;
    }

    this.scrollTop = 0;
  }
}

customElements.define('menu-pane', MenuPane);
